"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Integration = function Integration(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "IntegrationTitle IntegrationDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "IntegrationTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "IntegrationDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M20.242 3.006a.662.662 0 0 0-.4.214l-2.027 2.14-1.593-1.68a1.52 1.52 0 0 0-2.224.007L10.86 7.012a.74.74 0 0 0 0 1l5.396 5.702c.17.18.419.25.652.184a.694.694 0 0 0 .477-.503.74.74 0 0 0-.175-.688l-4.926-5.199 2.667-2.821c.094-.1.22-.102.315 0l4.126 4.354a.237.237 0 0 1 0 .34l-1.347 1.423a.736.736 0 0 0-.207.704c.06.257.252.457.496.519s.5-.024.665-.224l1.348-1.421a1.73 1.73 0 0 0 0-2.34l-1.586-1.674 2.035-2.148a.74.74 0 0 0 .136-.818.667.667 0 0 0-.69-.396zm-10.104 7.109a.662.662 0 0 0-.4.215l-1.431 1.51-.54-.577a.655.655 0 0 0-.955 0L3.67 14.58c-.608.64-.608 1.706 0 2.347l1.593 1.681-2.035 2.148a.736.736 0 0 0-.207.704c.06.257.252.457.496.52.244.061.5-.025.665-.224l2.035-2.14 1.579 1.666a1.527 1.527 0 0 0 2.224 0l3.143-3.318a.74.74 0 0 0 0-1l-.533-.57 1.432-1.51a.74.74 0 0 0 .136-.818.667.667 0 0 0-.69-.397.662.662 0 0 0-.4.214l-1.432 1.511L9.26 12.84l1.432-1.51a.74.74 0 0 0 .136-.818.667.667 0 0 0-.69-.397zM7.29 12.774l4.441 4.695-2.666 2.814c-.096.101-.22.101-.316 0L4.623 15.92c-.096-.102-.096-.232 0-.333l2.667-2.814z",
    id: "refIntegrationAL4l2RTfpT4"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refIntegrationAL4l2RTfpT4"
  }));
};

Integration.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Integration.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Integration;
exports["default"] = _default;